import React, { useState, useEffect } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    Text,
    Box,
    Flex,
    Image,
    Spinner,
    useDisclosure,
    Avatar,
} from "@chakra-ui/react";
import ReactStars from "react-stars";
import axiosClient from "../../../axios-client";

const RatingsModal = ({ isOpen, onClose, contentId }) => {
    const [ratings, setRatings] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasNext, setHasNext] = useState(false);
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const COMMENT_CHAR_LIMIT = 250;
    const [avgRating, setAvgRating] = useState(null);

    const CommentText = ({ comment }) => {
        const [expanded, setExpanded] = useState(false);
        const isLong = comment.length > COMMENT_CHAR_LIMIT;
        const displayedText = expanded ? comment : comment.slice(0, COMMENT_CHAR_LIMIT);

        return (
            <Text mt={2} fontSize="sm" color="white">
                {displayedText}
                {isLong && (
                    <>
                        {!expanded && "... "}
                        <Button
                            onClick={() => setExpanded(!expanded)}
                            variant="link"
                            size="sm"
                            colorScheme="orange"
                            ml={1}
                        >
                            {expanded ? "(voir moins)" : "(voir plus)"}
                        </Button>
                    </>
                )}
            </Text>
        );
    };

    const fetchRatings = async (page = 1, append = false) => {
        setLoading(true);
        try {
            if (!contentId) {
                return
            }
            const response = await axiosClient.get("ratings/", {
                params: {
                    content_id: contentId,
                    page,
                    page_size: 10,
                },
            });

            const dataResults = response.data.results;
            const average_rating = response.data.average_rating;
            setAvgRating(average_rating)
            setRatings((prev) => (append ? [...prev, ...dataResults] : dataResults));
            setHasNext(response.data.next !== null && dataResults.length > 0);
            setCurrentPage(page);
        } catch (error) {
            console.error("Error fetching ratings:", error);
        } finally {
            setLoading(false);
            setInitialLoading(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            fetchRatings(1, false);
        }
    }, [isOpen, contentId]);

    const handleLoadMore = () => {
        if (!loading && hasNext) {
            fetchRatings(currentPage + 1, true);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="2xl" scrollBehavior="inside" isCentered>
            <ModalOverlay />
            <ModalContent bg="#131022" color="white" >
                <ModalHeader>Tous les avis</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {initialLoading ? (
                        <Flex justify="center" align="center" py={10}>
                            <Spinner color="orange.400" />
                        </Flex>
                    ) : ratings.length === 0 ? (
                        <Text color="gray.400" textAlign="center" py={6}>
                            Aucun avis disponible pour le moment
                        </Text>
                    ) : (
                        ratings.map((rating, index) => (
                            <Box
                                key={rating.id || index}
                                bg="#2a2a4080"
                                p={4}
                                borderRadius="md"
                                mb={4}
                            >
                                <Flex align="center" mb={2}>
                                    <Avatar
                                        src={rating?.profileInfo?.avatar}
                                        alt={rating?.profileInfo?.username || "User"}
                                        boxSize="36px"
                                        borderRadius="full"
                                        objectFit="cover"
                                        mr={3}
                                    />
                                    <Box>
                                        <Text fontSize="sm" fontWeight="medium">
                                            {rating?.profileInfo?.username || "Utilisateur anonyme"}
                                        </Text>
                                        <Text fontSize="xs" color="gray.400">
                                            {new Date(rating.date_creation).toLocaleDateString("fr-FR")}
                                        </Text>
                                    </Box>
                                </Flex>

                                {/* <ReactStars
                                    count={5}
                                    value={rating.rating}
                                    edit={false}
                                    size={20}
                                    color2="#ffd700"
                                /> */}
                                 <div className="flex items-center gap-2">
                                            <ReactStars
                                                count={5}
                                                value={rating.rating}
                                                edit={false}
                                                size={20}
                                                color2={"#ffd700"}
                                            />
                                            {avgRating !== null && (
                                                <span className=" text-yellow-400 text-xs font-medium">
                                                    / {avgRating.toFixed(1)}
                                                </span>
                                            )}
                                        </div>

                                {rating.comment && <CommentText comment={rating.comment} />}
                            </Box>
                        ))
                    )}

                    {hasNext && (
                        <Flex justify="center" mt={4}>
                            <Button
                                onClick={handleLoadMore}
                                variant="link"
                                size="sm"
                                colorScheme="orange"
                                isLoading={loading}
                            >
                                Voir plus
                            </Button>
                        </Flex>
                    )}
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="orange" size="md" onClick={onClose}>
                        Fermer
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default RatingsModal;
